import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";

const initialState = {};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      apiSlice.endpoints.loginUser.matchFulfilled,
      (state, { payload }) => {
        state.userInfo = payload?.token;
      }
    );
    builder.addMatcher(
      apiSlice.endpoints.logoutUser.matchFulfilled,
      (state) => {
        delete state.userInfo;
      }
    );
  },
});

export default authSlice.reducer;
